import '../../../App.css';
import './ActivityLog.css';
import { useEffect, useState } from 'react';
import { Table } from 'antd';
import axios from 'axios';
import Appconfig from '../../../config/config'

function ActivityLog({ user_id }) {
    const userInfo = JSON.parse(localStorage.getItem('userdata'))

    let locale = {
        emptyText: 'No data!',
    };

    const getLocationInfo = (record) => {
        let info = record?.all_info;

        if (typeof info === 'string') {
            try {
                info = JSON.parse(info);
            } catch {
                info = null;
            }
        }

        const location = Array.isArray(info) ? info[0] : info || {};

        return {
            city: location?.city || record?.city || '-',
            state: location?.regionName || location?.state || record?.regionName || record?.state || '-',
            country: location?.country || record?.country || '-',
        };
    };

    const columns = [
        {
            title: 'Login Date & Time',
            // dataIndex: 'login-date-time',
            // width: '23%',
            render: (_, record) => (
                <span >{record.createdAt}</span>
            ),
        },
        {
            title: 'Login Status',
            dataIndex: 'login-status',
            render: (_, record) => (
                <span className={`font-bold text-[14px] ${record?.status == "Open" ? 'text-[#228b22]' : 'text-[#d50000]'}`}>
                    <b>{record?.status == "Open" ? "Login Successful" : "Login Failed"}</b>
                </span>
            ),
            // width: '20%'
        },
        {
            title: 'IP Address',
            dataIndex: 'ip_address',
            // render: (name) => `${name.first} ${name.last}`,
            // width: '18%'

        },
        {
            title: 'ISP',
            dataIndex: 'isp',
            render: (_, record) => (
                <span >{record.all_info && record.all_info[0].isp}</span>
            ),
        },
        {
            title: 'City / State / Country',
            key: 'location',
            render: (_, record) => {
                const location = getLocationInfo(record);

                return (
                    <span>
                        {location.city} / {location.state} / {location.country}
                    </span>
                );
            },
        },
    ];

    const [data, setData] = useState([])
    const [loading, setLoading] = useState(false);

    function getOnlineUser() {

        var data = JSON.stringify({
            "user_id": user_id ? user_id : userInfo._id,
            "user_type": "User"
        });

        var config = {
            method: 'post',
            url: `${Appconfig.apiUrl}reports/usersOnline`,
            headers: {
                'Content-Type': 'application/json'
            },
            data: data
        };

        axios(config)
            .then(function (response) {
                // SetOnlineUserList(response.data.resultData.reverse());
                setData(response.data.resultData)
                console.log(response)
            })
            .catch(function (error) {
                console.log(error);
            });
    }
    useEffect(() => {
        getOnlineUser()
    }, [])
    console.log(data)
    return (
        <section className="activity-log-section">
            <div className="activity-log-card">
                <div className="activity-log-card-header">
                    <div>
                        <h2>Activity Log</h2>
                        <p>Review recent account login activity.</p>
                    </div>
                </div>

                <div className="activity-log-card-body">
                    <Table
                        bordered
                        locale={locale}
                        columns={columns}
                        className="activity-log-table"
                        dataSource={data}
                        loading={loading}
                        pagination={false}
                        rowKey={(record, index) =>
                            record?._id || `${record?.createdAt}-${index}`
                        }
                        scroll={{ x: 760 }}
                    />
                </div>
            </div>
        </section>
    );
}

export default ActivityLog;
